import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { PicturePage, SignupPage, StartPage } from './components';
import { PAGES } from './util/constants';

import './App.css';

import { createComponent as cc } from 'react-fela';

const SHOWCASE_ENABLED = false; // Display a showcase if scrolled

const PageWrapper = cc(_ => ({
  width: '100%',
  height: '100%',
}));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: PAGES.START_PAGE,
      inTransition: false,
      touchStart: false,
      touchY: 0,
      deltaY: 0,
    };
  }

  componentDidMount() {
    if (SHOWCASE_ENABLED) {
      window.addEventListener('mousewheel', this.handleScroll);
      window.addEventListener('touchstart', this.handleTouchStart, false);
      window.addEventListener('touchmove', this.handleTouchMove, false);
    }
  }

  pageTransitionCompleted = pageId => {
    switch (pageId) {
    case PAGES.START_PAGE:
      this.setState({
        currentPage: PAGES.SUBSCRIBE_PAGE,
        inTransition: false,
      });
      break;
    case PAGES.PICTURE_PAGE:
      setTimeout(() => {
        this.setState({
          currentPage: PAGES.SUBSCRIBE_PAGE,
          inTransition: false,
        });
      }, 500);
      break;
    default:
      break;
    }
  };

  succesfullSignup = message => {};

  handleScroll = e => {
    const delta = this.state.deltaY + e.deltaY;

    if (
      !this.state.inTransition &&
      delta > 150 &&
      this.state.currentPage === PAGES.SUBSCRIBE_PAGE
    ) {
      this.setState({ currentPage: PAGES.PICTURE_PAGE, deltaY: 0 });
    } else {
      this.setState({ deltaY: delta });
    }
  };

  handleTouchStart = e => {
    this.setState({ touchStart: true, touchY: e.touches[0].clientY });
  };

  handleTouchMove = e => {
    if (this.state.touchStart) {
      if (this.state.touchY - e.touches[0].clientY > 100) {
        this.setState({
          touchStart: false,
          currentPage: PAGES.PICTURE_PAGE,
          deltaY: 0,
        });
      }
    }
  };

  componentWillUnmount() {
    if (SHOWCASE_ENABLED) {
      window.removeEventListener('mousewheel', this.handleScroll);
      window.removeEventListener('touchstart', this.handleTouchStart);
      window.removeEventListener('touchmove', this.handleTouchMove);
    }
  }

  render() {
    const { currentPage } = this.state;
    return (
      <PageWrapper ref={ this.wrapper }>
        {currentPage === PAGES.START_PAGE && (
          <StartPage finished={ this.pageTransitionCompleted } />
        )}
        {currentPage === PAGES.SUBSCRIBE_PAGE && (
          <SignupPage
            finished={ this.pageTransitionCompleted }
            onSuccess={ this.succesfullSignup } />
        )}
        {currentPage === PAGES.PICTURE_PAGE && (
          <PicturePage finished={ this.pageTransitionCompleted } />
        )}}
      </PageWrapper>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js